"use client";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
// import { getCloudinaryRemoteFetchURL } from "../cms/cloudinary";
import { SmartImage } from "../elements/smartimage";
import { usePixelatedConfig } from "../config/config.client";
import "./404.css";
/**
 * FourOhFour — Simple 404 page that randomly displays an image and short message.
 *
 * @param {array} [props.images] - Array of image objects used to display the 404 page. Each object should contain { img: string, text: string, description?: string }.
 */
FourOhFour.propTypes = {
    /** Array of image objects: { img: string, text: string, description?: string } */
    images: PropTypes.array.isRequired,
};
export function FourOhFour(props) {
    const images = props.images;
    const [randomIndex, setRandomIndex] = useState(0);
    // const [ cloudinaryURL, setCloudinaryURL ] = useState<string>('');
    const [imageURL, setImageURL] = useState('');
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setRandomIndex(randomIndex);
        setImageURL(images[randomIndex].img);
    }, [images]);
    const config = usePixelatedConfig();
    if (randomIndex !== null && imageURL /* cloudinaryURL */ !== '') {
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "fof-body-container", children: [_jsxs("h1", { className: "centered text-outline", children: ["404 - ", images[randomIndex].text] }), _jsx("div", { className: "centered-button", children: _jsx("a", { href: "/", target: "_self", rel: "noopener noreferrer", children: "Go Home" }) })] }), _jsx("div", { className: "fof-image-container", children: _jsx("div", { className: "fof-image-wrapper", children: _jsx(SmartImage, { src: imageURL, 
                            // src={cloudinaryURL} 
                            aboveFold: true, title: "Page Not Found - " + images[randomIndex].description, alt: "Page Not Found - " + images[randomIndex].description, cloudinaryEnv: config?.integrations?.cloudinary?.product_env ?? undefined, cloudinaryDomain: config?.integrations?.cloudinary?.baseUrl ?? undefined, cloudinaryTransforms: config?.integrations?.cloudinary?.transforms ?? undefined }) }) })] }));
    }
    else {
        return (_jsx(_Fragment, {}));
    }
}
